'use strict';
import angular from 'angular';

export default class AppStyleController {
    /*@ngInject*/
    constructor($stateParams, $http, $state, Application, $scope, Upload) {
        var vm = this;

        vm.cadres = [];
        vm.greenBackgrounds = [];
        vm.fileUploadTime = Date.now();

        vm.addBackground = function() {
            Application.general.greenBackground.push(vm.greenBackgrounds.length +1)
            vm.greenBackgrounds = Application.general.greenBackground;
        }

        vm.deleteBackground = function(row) {
            $http.post('api/applications/element', {id:$stateParams.id, index : (vm.greenBackgrounds.indexOf(row) +1),path:"/public/applications/" + $stateParams.id + "/interface/backgrounds/" + "bg_"+(vm.greenBackgrounds.indexOf(row) +1)+".jpg"}).then(function(){
                Application.general.greenBackground.splice(vm.greenBackgrounds.indexOf(row), 1);
                vm.fileUploadTime = Date.now();
                vm.greenBackgrounds = Application.general.greenBackground;
                Application.save($stateParams.id).then(function(){
                    // location.reload();
                });
            })
        }

        vm.addLine = function() {
            Application.general.frames.push(vm.cadres.length +1)
            vm.cadres = Application.general.frames;
        }

        vm.deleteLine = function(row) {
            $http.post('api/applications/element', {id:$stateParams.id, index : (vm.cadres.indexOf(row) +1), elem : 'frames' ,path:"/public/applications/" + $stateParams.id + "/interface/frames/" + "frame_"+(vm.cadres.indexOf(row) +1)+".png"}).then(function(){
                if(Application.general.frames.length > 1) {
                    Application.general.frames.splice(vm.cadres.indexOf(row), 1);
                    vm.cadres = Application.general.frames;
                }
                vm.fileUploadTime = Date.now();
                Application.save($stateParams.id).then(function(){
                });
            })
        }


        vm.uploadElem = function (file, path, ext, width, height) {
            Upload.upload({
                url: '/api/applications/'+$stateParams.id+'/upload',
                data: {file: file, path : path, width :608, height :405, ext : ext}
            }).then(function (resp) {
                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                vm.fileUploadTime = Date.now();
                Application.save($stateParams.id);
            }, function (resp) {
                console.log('Error status: ' + resp.status);
            }, function (evt) {
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
            });
        };
		//$('.bslider').bootstrapSlider();

        $http.get('/api/applications/' + $stateParams.id).then(
            function(res) {
                var data = res.data;
                Application.load($stateParams.id).then(function() {
                    $scope.$apply(function() {
                        vm.app = Application;
                        $scope.$watch('vm.app.general.inputs.normal', function(newValue, oldValue, scope) {
                            vm.app.general.inputs.focus['background-color'] = vm.app.general.inputs.normal['background-color'];
                            vm.app.general.inputs.focus['color'] = vm.app.general.inputs.normal['color'];
                            vm.app.general.inputs.focus['border-radius'] = vm.app.general.inputs.normal['border-radius'];
                            vm.app.general.inputs.focus['border-width'] = vm.app.general.inputs.normal['border-width'];

                            vm.app.general.inputs.success['background-color'] = vm.app.general.inputs.normal['background-color'];
                            vm.app.general.inputs.success['color'] = vm.app.general.inputs.normal['color'];
                            vm.app.general.inputs.success['border-radius'] = vm.app.general.inputs.normal['border-radius'];
                            vm.app.general.inputs.success['border-width'] = vm.app.general.inputs.normal['border-width'];

                            vm.app.general.inputs.error['background-color'] = vm.app.general.inputs.normal['background-color'];
                            vm.app.general.inputs.error['color'] = vm.app.general.inputs.normal['color'];
                            vm.app.general.inputs.error['border-radius'] = vm.app.general.inputs.normal['border-radius'];
                            vm.app.general.inputs.error['border-width'] = vm.app.general.inputs.normal['border-width'];
                            //Ajout des cadres
                            if(Application.general.frames.length > 0) vm.cadres = Application.general.frames;
                            else Application.general.frames = [1]; vm.cadres = Application.general.frames;
                            //Ajout des fond verts
                            if(Application.general.greenBackground.length > 0) vm.greenBackgrounds = Application.general.greenBackground;
                            else Application.general.greenBackground = [1]; vm.greenBackgrounds = Application.general.greenBackground;
                        }, true);
                    }); 
                });
            }, function(error) {
                if (error.status == "404") {
                    $state.go('application_main');
                }
                console.log(error);
            });

		vm.save = function() {
			Application.save($stateParams.id);
		}
        
        vm.next = function() {
            if(Application.general.mode.value == 'greenBackground' && vm.greenBackgrounds.length > 1) Application.general.storyboard[2].status = true;
            else Application.general.storyboard[2].status = false;
            if(vm.cadres.length > 1) Application.general.storyboard[3].status = true;
            else Application.general.storyboard[3].status = false;
            Application.save($stateParams.id);
            $state.go('application_screen_main', { id: $stateParams.id });
		}
    }

}


// WEBPACK FOOTER //
// ./client/app/application/style/style.controller.js